import { Fade, Flex, Spacer, Text, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { Link, useMatch } from 'react-router-dom'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'
import SidebarLink from './SidebarLink'

const SidebarLinkGroup = ({ name, path, icon, childLinks = [], depth = 0 }) => {
  const selected = useMatch(path)
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: false })
  const paddingLeft = depth > 0 ? 5 + depth * 4 : 5

  return (
    <Flex direction={'column'} gap={1}>
      <Flex alignItems={'center'}>
        {path === '' && (
          <Flex
            pl={paddingLeft}
            pr={5}
            py={3}
            _hover={{ bg: 'teal.600', color: 'white' }}
            bg={selected ? 'teal.600' : ''}
            color={selected ? 'white' : ''}
            alignItems={'center'}
            gap="2"
            w="100%"
            onClick={(e) => {
              e.stopPropagation()
              onToggle()
            }}
          >
            {icon}
            <Text fontSize="md">{name}</Text>
            <Spacer />
            {isOpen ? <FaAngleUp /> : <FaAngleDown />}
          </Flex>
        )}
        {path !== '' && (
          <Link to={path} style={{ textDecoration: 'none', width: '90%' }}>
            <Flex
              pl={paddingLeft}
              pr={5}
              py={3}
              _hover={{ bg: 'teal.600', cursor: 'pointer', color: 'white' }}
              bg={selected ? 'teal.600' : ''}
              color={selected ? 'white' : ''}
              alignItems={'center'}
              gap="2"
            >
              {icon}
              <Text fontSize="md">{name}</Text>
              <Spacer />
            </Flex>
          </Link>
        )}
      </Flex>

      <Fade in={isOpen}>
        <Flex direction={'column'} gap={'1'} display={isOpen ? 'flex' : 'none'}>
          {childLinks.map((link) => {
            if (Array.isArray(link.childLinks)) {
              return (
                <SidebarLinkGroup
                  key={link.name + (link.path || '')}
                  name={link.name}
                  path={link.path}
                  icon={link.icon}
                  childLinks={link.childLinks}
                  depth={depth + 1}
                />
              )
            }
            // One level deeper than this group: the text lines up with a nested
            // group's header (padding 5 + depth * 4).
            return (
              <SidebarLink
                key={link.path || link.name}
                name={link.name}
                path={link.path}
                icon={link.icon}
                defaultBackgroundColor={'teal.400'}
                indent={(depth + 1) * 4}
              />
            )
          })}
        </Flex>
      </Fade>
    </Flex>
  )
}

export default SidebarLinkGroup
